import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type ISearchParameters, OPERATOR_SORT } from '@features/filters/types';
import { CONTRIBUTION_BETS_DEFAULT_SORT_FIELD } from '@modules/contributionBetsReport/constants';

interface IInitialState {
  searchParameters: ISearchParameters;
}

export const initialContributionBetsSearchParameters: ISearchParameters = {
  page: 1,
  size: 10,
  filters: [],
  isIncludeExternalBonuses: true,
  sorts: [
    {
      order: OPERATOR_SORT.DESC,
      field: CONTRIBUTION_BETS_DEFAULT_SORT_FIELD,
    },
  ],
};

const initialState: IInitialState = {
  searchParameters: initialContributionBetsSearchParameters,
};

const contributionBetsReportSlice = createSlice({
  initialState,
  name: 'contributionBetsReport',
  reducers: {
    setSearchParameters(
      state: IInitialState,
      action: PayloadAction<Partial<ISearchParameters>>
    ) {
      state.searchParameters = { ...state.searchParameters, ...action.payload };
    },
  },
});

export default contributionBetsReportSlice.reducer;

export const { setSearchParameters } = contributionBetsReportSlice.actions;
